
import * as utils from "../utils";

import store from "../store";
import * as types from "./constants";

export function submitRsvp(data, captcha=null) {

  const form_data = Object.assign(data, {captcha: JSON.parse(captcha)});
  const url = `/ajax/event/${window.evite_event.id}/view/rsvp`;

  setFormSubmitting(true);

  window.$.post(url, form_data, (response) => {
    window.location = response.location;
  })
  .fail((xhr, status, data) => {
    setFormSubmitting(false);
    utils.handleCaptcha(xhr, status, data, function (captcha) {
      submitRsvp(form_data, captcha);
    });
  });
}

export function toggleRsvpFormVisible() {
  store.dispatch({
    type: types.TOGGLE_RSVP_FORM_VISIBLE
  })
}

export function setFormSubmitting(submitting) {
  store.dispatch({
    type: types.SET_FORM_SUBMITTING,
    submitting
  })
}

export function setNotYou() {
  store.dispatch({
    type: types.SET_NOT_YOU
  })
}

export function unsetNotYou() {
  store.dispatch({
    type: types.UNSET_NOT_YOU
  })
}

export function setEditingGuestName(editing, guestName) {
  store.dispatch({
    type: types.SET_EDITING_GUEST_NAME,
    editing,
    guestName
  })
}

export function setGuestName(guestName) {
  store.dispatch({
    type: types.SET_GUEST_NAME,
    guestName
  })
}

export function setAltGuestName(altGuestName) {
  store.dispatch({
    type: types.SET_ALT_GUEST_NAME,
    altGuestName
  })
}

export function setGuestEmail(guestEmail) {
  store.dispatch({
    type: types.SET_GUEST_EMAIL,
    guestEmail
  })
}

export function setTotalAdults(adultCount) {
  store.dispatch({
    type: types.SET_TOTAL_ADULTS,
    adultCount
  })
}

export function setTotalKids(kidCount) {
  store.dispatch({
    type: types.SET_TOTAL_KIDS,
    kidCount
  })
}

export function setNotifyNewComments(notify) {
  store.dispatch({
    type: types.SET_NOTIFY_NEW_COMMENTS,
    notify
  })
}

export function setNotifyNewRsvp(notify) {
  store.dispatch({
    type: types.SET_NOTIFY_NEW_RSVP,
    notify
  })
}

export function setNotifyMarketing(notify) {
  store.dispatch({
    type: types.SET_NOTIFY_MARKETING,
    notify
  })
}

export function setRsvpComment(comment) {
  store.dispatch({
    type: types.SET_RSVP_COMMENT,
    comment
  })
}

export function setRsvpResponse(response) {
  store.dispatch({
    type: types.SET_RSVP_RESPONSE,
    response
  })
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/actions.es6